<div
  class="attached-elements"
>
  <div
    class="attached-elements-header"
  >
    <input
      nbInput
      fieldSize="small"
      placeholder="Поиск связанных элементов"
    >

    <div class="tabs">
      <div
        class="tabs-item"
        (click)="showProductBlocks('table')"
        [ngClass]="{'active': elementsListView === 'table'}"
        i18n-nbTooltip="@@BigThumbnails"
        nbTooltip="Большие миниатюры"
      >
        <nb-icon icon="grid-outline"/>
      </div>
      <div
        class="tabs-item"
        (click)="showProductBlocks('list')"
        [ngClass]="{'active': elementsListView === 'list'}"
        i18n-nbTooltip="@@TableView"
        nbTooltip="Отображать таблицей"
      >
        <nb-icon icon="menu-outline"/>
      </div>
    </div>
  </div>

  <div *ngFor="let item of damRelatedCollection">
    <app-dam-related-collection
      [model]="model"
      [damRelatedCollection]="item"
      [uri]="uri"
    />
  </div>
</div>
